import { render, staticRenderFns } from "./CustomerRoutes.vue?vue&type=template&id=bc542040&scoped=true&"
import script from "./CustomerRoutes.vue?vue&type=script&lang=js&"
export * from "./CustomerRoutes.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRoutes.vue?vue&type=style&index=0&id=bc542040&lang=scss&scoped=true&"
import style1 from "./CustomerRoutes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc542040",
  null
  
)

export default component.exports